export const userState = {
  template: {},
  loggedin: false,
  displayName: '',
  pnr: '',
  loginInformation: {},
  guardian: {
    pnr: '',
    displayName: '',
    givenName: '',
    familyName: '',
    email: '',
    email_verified: false,
    phone_number: '',
    phone_number_verified: false,
    street1: '',
    street2: '',
    city: '',
    postcode: '',
    photo_url: '',
    disabled: false,
    created: null,
    updated: null,
    pnrx: []
  },
  addedguardians: [],
  child: {
    idNumber: '',
    displayName: '',
    givenName: '',
    familyName: '',
    photo_url: '',
    disabled: false,
    created: null,
    updated: null,
    childInformation: [],
    inKindergarten: 1,
    importantInformation: '',
    kinderGartenAbsence: 0,
    needTranslator: false,
    heartLanguage: 'nb',
    heartLanguageProficency: 1,
    parentsHeartLanguage: 'nb',
    houseLanguage: 'nb'
  },
  childInformation: {
    idNumber: '',
    pnr: '',
    displayName: '',
    givenName: '',
    familyName: '',
    photo_url: '',
    disabled: false,
    created: null,
    updated: null,
    childInformation: [],
    inKindergarten: 1,
    importantInformation: '',
    kinderGartenAbsence: 0,
    needTranslator: false,
    heartLanguage: 'nb',
    heartLanguageProficency: 1,
    parentsHeartLanguage: 'nb',
    houseLanguage: 'nb',
    importantInformation: '',
    lookingForwardTo: '',
    likes: '',
    schoolToKnow: '',
    exitedTo: ''
  },
  feideuser: {},
  allowedAdmins: ['61862400282'],
  allowedKindergartenAdmins: [
    '27833048959',
    '41859502502', // Tindlund
    '06887799502', // Tubus
    '13894498220' // Læringsverkstedet - Store Tune
  ]
}
